
import React, { useCallback, useContext, useState, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@material-ui/core'
import cs from 'classnames'
import { EDITOR_MAIN_SETTINGS, EDITOR_MAIN_SETTINGS_MENU } from 'config/constants/mainView'
import { TranslationContext } from 'contexts/TranslationContext'
import { useAction } from 'hooks'
import { setEditorSettings, showEditorMainSettings } from 'actions/mainView'
import { FormContextProvider } from 'providers/FormContextProvider'
import { MenuItemType } from 'types/editorSettings'
import { selectViewSettings, selectBehaviourSettings, selectRenderSettings } from 'selectors/mainView'
import { EditorSettingsParams } from './EditorSettingsParams'
import './EditorSettings.scss'
import { Header } from './components/Header'
import { Footer } from './components/Footer'

export const EditorSettingsComponent = () => {
  const { t } = useContext(TranslationContext)
  const [ activeMenuItem, setActive ] = useState<MenuItemType>(EDITOR_MAIN_SETTINGS_MENU[0].key)
  const hideEditorMainSettings = useAction(showEditorMainSettings, false)
  const viewSettings = useSelector(selectViewSettings)
  const behaviourSettings = useSelector(selectBehaviourSettings)
  const renderSettings = useSelector(selectRenderSettings)
  const settingsMap = useMemo(() => ({
    [EDITOR_MAIN_SETTINGS.VIEW]: viewSettings,
    [EDITOR_MAIN_SETTINGS.BEHAVIOUR]: behaviourSettings,
    [EDITOR_MAIN_SETTINGS.RENDER]: renderSettings,
  }), [ viewSettings, behaviourSettings, renderSettings ])
  const initialState = useMemo(() => settingsMap[activeMenuItem], [ settingsMap, activeMenuItem ])
  const action = setEditorSettings.bind(null, activeMenuItem)
  const onClose = useCallback(() => {
    hideEditorMainSettings()
  }, [ hideEditorMainSettings ])

  return (
    <Box className="editor-settings">
      <Header t={t} onClose={onClose} />
      <FormContextProvider<typeof initialState>
        initialState={initialState}
        action={action}
        onClose={onClose}
      >
        <Box display="flex" gridGap={10} className="editor-settings__body">
          <Box className="editor-settings__menu">
            {EDITOR_MAIN_SETTINGS_MENU.map(menuItem => (
              <div
                key={menuItem.name}
                onClick={() => setActive(menuItem.key)}
                className={cs('editor-settings__menu-item', {
                  active: menuItem.key === activeMenuItem,
                })}
              >
                {t(menuItem.name)}
              </div>
            ))}
          </Box>
          <EditorSettingsParams activeMenuItem={activeMenuItem} />
        </Box>
        <Footer t={t} activeMenuItem={activeMenuItem} />
      </FormContextProvider>
    </Box>
  )
}
